import React from 'react';
import '../styles/pages/Services.css';

function Services() {
  const services = [
    {
      title: 'Planting',
      description: 'Custom garden installations and plantings',
      details: [
        'Native plant selections',
        'Garden bed design and prep',
        'Tree and shrub planting',
        'Seasonal color arrangements'
      ],
      image: '/images/flowers.jpeg'
    },
    {
      title: 'Fence Installation',
      description: 'Professional fence installation and repair',
      details: [
        'Wood and composite fencing',
        'Privacy and decorative fences',
        'Fence repair and maintenance',
        'Professional installation'
      ],
      image: '/images/fence.jpeg'
    },
    {
      title: 'Decking',
      description: 'Beautiful custom deck construction',
      details: [
        'Wood deck construction',
        'Composite decking options',
        'Deck repair and restoration',
        'Custom designs'
      ],
      image: '/images/deck.jpeg'
    },
    {
      title: 'Maintenance Plans',
      description: 'Comprehensive landscape care - Monthly or Weekly available',
      details: [
        'Deep landscape cleaning',
        'Plant health assessment',
        'Lawn mowing and edging',
        'Weekly or Monthly scheduling options'
      ],
      image: '/images/grass.jpeg'
    }
  ];

  return (
    <div className="services">
      <div className="services-header">
        <h1>Our Services</h1>
        <p>Comprehensive landscaping solutions for every need</p>
      </div>

      <div className="container">
        <div className="services-detailed-grid">
          {services.map((service, index) => (
            <div key={index} className="service-detailed-card">
              <div className="service-image-wrapper">
                <img src={service.image} alt={service.title} />
              </div>
              <div className="service-content">
                <h3>{service.title}</h3>
                <p className="description">{service.description}</p>
                <ul className="details">
                  {service.details.map((detail, i) => (
                    <li key={i}>{detail}</li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Services;
